import React, { useState, useEffect } from "react";
import { Search } from "react-feather";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  ButtonGroup,
} from "reactstrap";
import DataTable from "react-data-table-component";
import moment from "moment";

export default function ModalSelect(props) {
  const { open, data, handleClose, handleSelect } = props;
  const [tableOps, setTableOps] = useState({
    page: 1,
    limit: 10,
  });
  const handlePerRowsChange = (newPerPage, page) => {
    setTableOps({ ...tableOps, limit: newPerPage, page: 1 });
  };
  const handlePageChange = (page) => {
    setTableOps({ ...tableOps, page: page });
  };

  const columns = [
    {
      name: "NORM",
      sortable: false,
      width: "80px",
      cell: (row) => row?.NORM,
    },
    {
      name: "Nama Pasien",
      sortable: false,
      width: "200px",
      cell: (row) => row?.NAMAPASIEN,
    },
    {
      name: "Alamat",
      sortable: false,
      cell: (row) => row?.ALAMATPASIEN,
    },
    {
      name: "Action",
      sortable: false,
      width: "130px",
      cell: (row, index) => (
        <Button
          color="success"
          // style={{ width: "125px" }}
          onClick={() => {
            handleSelect(row?.NORM);
          }}
        >
          Pilih
        </Button>
      ),
    },
  ];
  console.log("data", data);
  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-lg"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose} className="bg-primary">
        Pilih Pasien
      </ModalHeader>
      <ModalBody>
        <DataTable
          data={data}
          columns={columns}
          noHeader
          pagination
          paginationDefaultPage={tableOps?.page}
          paginationPerPage={tableOps?.limit}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </ModalBody>
    </Modal>
  );
}
